import {PropsWithChildren, ReactNode} from 'react';

interface AuthLayoutProps extends PropsWithChildren {
  title?: string;
  subtitle?: string;
  brandPanel?: ReactNode;
}

export default function AuthLayout({
  title,
  subtitle,
  children,
  brandPanel,
}: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-base-200">
      <div className="mx-auto flex min-h-screen w-full max-w-6xl items-center px-4 py-8 sm:px-6 lg:px-8">
        <div className="grid w-full gap-8 lg:grid-cols-2 lg:items-center">
          <section className="order-2 hidden rounded-xl border border-base-300 bg-base-100 p-10 shadow-sm lg:order-1 lg:block">
            {brandPanel ?? (
              <>
                <img
                  src="/branding/pantry-savvy-logo.svg"
                  alt="Pantry Savvy"
                  className="h-auto w-56"
                />
                <h1 className="mt-6 text-4xl font-semibold leading-tight text-base-content">
                  Plan smarter.
                  <br/>
                  Cook faster.
                  <br/>
                  Spend less.
                </h1>
                <p className="mt-6 max-w-sm text-sm leading-6 text-base-content/70">
                  Access your meal plans, shopping workflows, and pantry tools from one secure workspace.
                </p>
              </>
            )}
          </section>

          <section className="order-1 lg:order-2">
            <div className="mx-auto w-full max-w-md rounded-xl border border-base-300 bg-base-100 p-6 shadow-sm sm:p-8">
              {(title || subtitle) && (
                <div className="text-left">
                  <img
                    src="/branding/pantry-savvy-logo.svg"
                    alt="Pantry Savvy"
                    className="mb-5 h-auto w-40"
                  />
                  {title ? <h2 className="text-2xl font-semibold text-base-content">{title}</h2> : null}
                  {subtitle ? <p className="mt-1 text-sm text-base-content/70">{subtitle}</p> : null}
                </div>
              )}

              <div className={title || subtitle ? 'mt-6' : ''}>{children}</div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
